import React from 'react';
import { Star } from 'lucide-react';
interface MiniProps {
  initials: string;
  name: string;
  role: string;
  country: string;
  text: string;
}
const Mini = ({
  initials,
  name,
  role,
  country,
  text
}: MiniProps) => <div className="bg-brand-paper border border-brand-line rounded-lg p-3 brunson-shadow" data-id="element-214">
    <div className="flex items-center gap-2 mb-2" data-id="element-215">
      <div className="w-8 h-8 rounded-full bg-brand-orange text-white font-display font-bold text-xs flex items-center justify-center shrink-0" data-id="element-216">
        {initials}
      </div>
      <div className="flex-1 min-w-0" data-id="element-217">
        <div className="flex text-brand-orange" data-id="element-218">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-219" />)}
        </div>
        <p className="text-[11px] font-bold text-white truncate" data-id="element-220">{name}</p>
        <p className="text-[9px] text-brand-mute font-medium" data-id="element-221">
          {role} · {country}
        </p>
      </div>
    </div>
    <p className="text-xs text-brand-ink italic leading-snug font-medium" data-id="element-222">
      "{text}"
    </p>
  </div>;
export function SocialProofBar() {
  const items = [{
    initials: 'MA',
    name: 'Ing. Matías Ávila',
    role: 'Docente de Producción Acuícola',
    country: 'Misiones',
    text: 'El lunes tenía que explicar el ciclo del nitrógeno y el biofloc. El viernes anterior descubrí Acuicultura Pro. El lunes lo dicté con tablas listas, actividades prácticas y los alumnos lo entendieron al primer intento.'
  }, {
    initials: 'VG',
    name: 'Prof. Valeria Gallo',
    role: 'Capacitadora técnica',
    country: 'Corrientes',
    text: 'Mis estudiantes pasaron de no saber calcular el FCR a diseñar planes de alimentación completos. El sistema hace el 80% del trabajo del docente.'
  }, {
    initials: 'RS',
    name: 'Téc. Ricardo Santillán',
    role: 'Instructor técnico',
    country: 'Formosa',
    text: 'Llevaba 3 años improvisando con materiales de diferentes fuentes. Esto lo reemplaza todo. Y lo supera.'
  }];
  return <section className="bg-brand-creamAlt py-5 px-4 border-y border-brand-line" data-id="element-223">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-224">
        {items.map((it, i) => <Mini key={i} {...it} data-id="element-225" />)}
      </div>
    </section>;
}